import { Box, } from "@mui/material";
import Grid from '@mui/material/Grid';
import { EventPhoto, PhotoEvent } from 'common-models';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Configuration } from '../../Configuration';

type EventLinkProps = {
    event: PhotoEvent;
}

const EventLink: FC<EventLinkProps> = ({ event }) => {


    function getEventImageSrcSet(photo?: EventPhoto): string {
        if (photo) {
            return photo.webSizes.map(y => `${Configuration.StaticSiteUrl}/events/${photo.eventId}/${photo.id}-${y.width}.jpg ${y.width}w`).join(', ')
        }
        return ''
    }

    return (
        <Grid container >
            <Box
                component={Link}
                to={{ pathname: `/events/${event.id}` }}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderRadius: 1,
                    borderColor: 'grey.500',
                    p: 2,
                    m: 2,
                    height: '10rem',
                    width: '100%',
                    display: 'block',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        m: 2.4,
                        boxShadow: '0.5rem 0.5rem 1rem 0 rgba(0, 0, 0, 0.2)',
                        '& img': {
                            opacity: 0.7,
                        },
                    },
                }}
            >
                {
                    event.frontImage
                        ? <img
                            style={{
                                position: 'absolute',
                                width: '100%',
                                minHeight: '100%',
                                left: 0,
                                top: '50%',
                                transform: 'translate(0, -50%)',
                                opacity: 0.4,
                                zIndex: -1,
                                transition: 'opacity 0.2s ease-in-out',
                            }}
                            alt=''
                            srcSet={getEventImageSrcSet(event.frontImage)}
                            sizes="(min-width: 1200px) 530px, (min-width: 992px) 440px, (min-width: 768px) 320px, (min-wid5th: 576px) 230px, 90vw"
                        />
                        : <></>
                }
                <Box sx={{
                    p: 0.5,
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'dark'
                            ? 'rgba(0, 0, 0, 0.8)'
                            : 'rgba(255, 255, 255, 0.87)',
                    borderRadius: 1,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: 'text.primary',
                    textAlign: 'center',
                    color: 'text.primary',
                    position: 'relative',
                    zIndex: 1,
                }}>
                    {event.title}
                </Box>
            </Box>
        </Grid>
    )
}


export { EventLink };
